<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goUserProfilePage()">
        <ion-icon class="back-icon" color="dark" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'CREDIT.lbl.credit' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <div class="content-div ion-padding-horizontal">
      <ion-segment scrollable [(ngModel)]="type" (ionChange)="searchCredit()">
        <ion-segment-button value="active">
          <ion-label>{{ 'LBL.active' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="redeemed">
          <ion-label>{{ 'CREDIT.lbl.redeemed' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </ion-toolbar>
  <ion-toolbar class="toolbar-select-all">
    <div class="content-div">
      <app-select-all [total]="creditList.length" *ngIf="creditList?.length" [editMode]="false"></app-select-all>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-horizontal" color="light">
  <div class="content-div">
    <div class="full-width-height viewport-div" *ngIf="creditList?.length">
      <cdk-virtual-scroll-viewport [itemSize]="100">
        <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list>
          <ion-card class="card-margin" *cdkVirtualFor="let credit of creditList; trackBy: trackByFn" button>
            <ion-item class="item item-card" lines="none">
              <ion-label class="ion-no-margin" color="dark">
                <div>
                  <ion-text class="font-14 font-bold" *ngIf="credit.productId">
                    {{ 'PRODUCT.account.' + credit.productId + '.short' | translate }}
                    <ng-container *ngIf="credit?.upgrade"> ({{ 'BTN.upgrade' | translate }})</ng-container>
                  </ion-text>
                </div>
                <div class="line-1">
                  <ion-text class="font-12" color="medium" *ngIf="credit.productId">{{ 'PRODUCT.account.' + credit.productId + '.desc' | translate }}</ion-text>
                </div>
                <div>
                  <ion-icon class="font-12 icon" color="medium" name="calendar-outline"></ion-icon>
                  <ion-text class="font-12" color="medium">{{ format(credit?.createBy?.time?.seconds * 1000) }}</ion-text>
                </div>
                <div>
                  <ion-icon class="font-12 icon" color="medium" src="./assets/wedding/icon/gift/currency.svg"></ion-icon>
                  <ion-text class="font-12" color="medium">{{ credit.price.amount | currency: credit?.price?.currency: 'symbol' }}</ion-text>
                </div>
                <div *ngIf="credit?.gift && credit?.share?.length">
                  <ion-icon class="font-12 icon" color="medium" src="./assets/wedding/icon/gift/gift.svg"></ion-icon>
                  <ion-text class="font-12" color="medium">{{ format(credit.share[credit.share.length - 1].by?.time?.seconds * 1000, 'do MMM yyyy, EEEE h:mm a') }}</ion-text>
                </div>
              </ion-label>
              <ion-button class="btn" shape="round" (click)="action(credit)" slot="end">
                <ng-container *ngIf="type === 'active'">
                  {{ 'CREDIT.btn.activate' | translate }}
                </ng-container>
                <ng-container *ngIf="type === 'redeemed'">
                  {{ 'CREDIT.lbl.redeemed' | translate }}
                </ng-container>
              </ion-button>
            </ion-item>
          </ion-card>
        </ion-list>
      </cdk-virtual-scroll-viewport>
    </div>
    
    <div class="full-width-height center vertical-center" *ngIf="!creditList?.length">
      <ion-label class="ion-text-center ion-margin ion-padding" color="medium">
        <ion-icon class="center icon-cactus" src="./assets/wedding/icon/general/no-record.svg"></ion-icon>
        <div class="ion-margin-top font-14">{{ 'LBL.no_found' | translate }}</div>
      </ion-label>
    </div>
  </div>
  
</ion-content>
<ion-footer *ngIf="!accountId && !creditList?.length">
  <ion-toolbar>
    <div class="content-div">
      <ion-button class="ion-margin" expand="block" color="primary" fill="solid" type="button" (click)="goSubscriptionAccountPage()">
        {{ 'PAYMENT.btn.purchase' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
